// extracted by mini-css-extract-plugin
export default {"melodyVideo":"jI-z","isFullWidth":"kI-z","landingPageVideo":"lI-z","play":"mI-z","iframeVideo":"nI-z","playHidden":"oI-z","fullwidth":"pI-z"};